export default () => ({
    bankOperationsSelected: [],
    RDOperationsSelected: [],
    groupedSelected: false,
    uuidGroupedSelected: null,
    disableGroups: false,
    comment: null,
    disableAll: false
});
